module.exports = __webpack_public_path__ + "static/img/315.bdfd68c4.png";